import React from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { RawLinkButton } from "../../../LinkButton";

export interface IAPIFieldsDialogProps {
  isOpen: boolean;
  cancel: () => void;
  submit: () => void;
}

const RemoveAPIsDialog = (props: IAPIFieldsDialogProps) => {
  const { isOpen, cancel, submit } = props;

  return (
    <Dialog open={isOpen} onClose={cancel} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{`System Status Change Confirmation`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Changing the System of this interface will clear all APIs that are selected for it when you Save these interface changes. Continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <RawLinkButton onClick={submit} color="primary">
          Okay
        </RawLinkButton>
        <RawLinkButton onClick={cancel} color="primary">
          Cancel
        </RawLinkButton>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveAPIsDialog;
